import { useLocation, Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { cn } from '../../lib/utils';

const routeLabels: Record<string, string> = {
  '/': 'Главная',
  '/employees': 'Сотрудники',
  '/departments': 'Подразделения',
  '/locations': 'Локации',
  '/schedules': 'Графики работы',
  '/attendance': 'Посещаемость',
  '/bio-cards': 'Карточки терминалов',
  '/time-records': 'Записи времени',
};

export function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(Boolean);

  const breadcrumbs: Array<{ name: string; href: string; icon?: typeof Home }> = [
    { name: 'Home', href: '/', icon: Home }
  ];

  let href = '';
  pathnames.forEach((pathname) => {
    href += `/${pathname}`;
    const name = routeLabels[href] || pathname.charAt(0).toUpperCase() + pathname.slice(1);
    breadcrumbs.push({ name, href });
  });

  if (breadcrumbs.length === 1) return null;

  return (
    <nav className="flex items-center space-x-2 text-sm">
      {breadcrumbs.map((breadcrumb, index) => {
        const isLast = index === breadcrumbs.length - 1;
        const isFirst = index === 0;

        return (
          <div key={breadcrumb.href} className="flex items-center">
            {index > 0 && (
              <ChevronRight className="w-4 h-4 text-muted-foreground mx-2" />
            )}
            <Link
              to={breadcrumb.href}
              className={cn(
                'flex items-center gap-1 hover:text-foreground transition-colors',
                isLast
                  ? 'text-foreground font-medium'
                  : 'text-muted-foreground'
              )}
            >
              {isFirst && breadcrumb.icon && (
                <breadcrumb.icon className="w-4 h-4" />
              )}
              {breadcrumb.name}
            </Link>
          </div>
        );
      })}
    </nav>
  );
}